<div class="image-viewer">
    <div (click)="dialogRef.close()" class="close" matTooltipPosition="after">
        <i class="fa fa-times"></i>
    </div>
    <swiper-container
        #swiperRef
        navigation="true"
        zoom="true"
        loop="false"
        mousewheel="false"
        (wheel)="onScroll($event)"
        (swiperslidechange)="onSlideChange($event)">
        @if (data.singlePdf) {
            @if (pdfLoading) {
                <swiper-slide>
                    <div class="swiper-zoom-container" data-swiper-zoom="8">
                        <div class="pdf-loading">
                            <mat-spinner diameter="50"></mat-spinner>
                            <p>PDF laden...</p>
                        </div>
                    </div>
                </swiper-slide>
            } @else if (pdfError) {
                <swiper-slide>
                    <div class="swiper-zoom-container" data-swiper-zoom="8">
                        <div class="pdf-error">
                            <mat-icon>error</mat-icon>
                            <p>{{ pdfError }}</p>
                        </div>
                    </div>
                </swiper-slide>
            } @else {
                @for (pageNum of pdfPages; track pageNum; let C = $index) {
                    <swiper-slide>
                        <div class="swiper-zoom-container" data-swiper-zoom="8">
                            <canvas #pdfCanvas></canvas>
                            @if (totalPdfPages > 1) {
                                <div class="pdf-controls">
                                    <span class="pdf-page-info"> {{ pageNum }} / {{ totalPdfPages }} </span>
                                </div>
                            }
                        </div>
                    </swiper-slide>
                }
            }
        } @else if (data.singleImage) {
            <swiper-slide>
                <div class="swiper-zoom-container">
                    <img [src]="data.singleImage" />
                </div>
            </swiper-slide>
        } @else {
            @for (image of images; track image) {
                <swiper-slide>
                    <div class="swiper-zoom-container">
                        <img [src]="image.image" />
                        <div class="info">
                            @if (!hideTime && image.imageObject.created_at) {
                                <mat-chip>
                                    <div>{{ image.imageObject.created_at | date: 'd MMM yyyy H:mm' }}</div>
                                </mat-chip>
                            }
                            @if (image.imageObject.user?.name; as name) {
                                <mat-chip>
                                    <div><i class="fa-solid fa-user-large me-1"></i> {{ name }}</div>
                                </mat-chip>
                            }

                            @if (workarea?.number; as workareaNumber) {
                                <mat-chip>
                                    <div><i class="fa-solid fa-hashtag me-1"></i> Werkvak {{ workareaNumber }}</div>
                                </mat-chip>
                            }

                            @if (workarea?.street) {
                                <mat-chip>
                                    <div>
                                        <i class="fa-solid fa-location-dot me-1"></i>
                                        {{ workarea.street }} {{ workarea.housenumber }}, {{ workarea.zipcode }}
                                        {{ workarea.place }} {{ workarea.road_number ? '-' : '' }}
                                        {{ workarea.road_number }}
                                    </div>
                                </mat-chip>
                            }
                        </div>
                    </div>
                </swiper-slide>
            }
        }
    </swiper-container>
</div>
